import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface StatsCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  trend?: {
    direction: 'up' | 'down';
    percentage: number;
  };
  isLoading?: boolean;
}

const StatsCard: React.FC<StatsCardProps> = ({ icon, label, value, trend, isLoading }) => {
  if (isLoading) {
    return (
      <div 
        className="h-[120px] min-w-[240px] bg-[#141414] rounded-xl p-5 px-6 border border-[#1F1F1F] flex flex-col justify-between"
        data-testid="stats-card-skeleton"
      >
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="h-4 bg-[#1F1F1F] rounded w-24 mb-3 animate-pulse" />
            <div className="h-8 bg-[#1F1F1F] rounded w-32 animate-pulse" />
          </div>
          <div className="w-12 h-12 bg-[#1F1F1F] rounded-[10px] animate-pulse" />
        </div>
      </div>
    );
  }

  return (
    <div className="h-[120px] min-w-[240px] bg-[#141414] rounded-xl p-5 px-6 border border-[#1F1F1F] flex flex-col justify-between">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-[#8F8F8F] text-sm font-medium leading-5 mt-3">{label}</p>
          <p className="text-white text-[28px] font-bold leading-9 mt-1">{value}</p>
          
          {trend && (
            <div className="flex items-center gap-1 mt-2">
              {trend.direction === 'up' ? (
                <TrendingUp size={12} className="text-[#23F47C]" />
              ) : (
                <TrendingDown size={12} className="text-[#FF4757]" />
              )}
              <span 
                className={`text-xs font-semibold ${
                  trend.direction === 'up' ? 'text-[#23F47C]' : 'text-[#FF4757]'
                }`}
              >
                {trend.percentage}%
              </span>
            </div>
          )}
        </div>
        
        <div className="w-12 h-12 bg-[rgba(35,244,124,0.1)] rounded-[10px] flex items-center justify-center text-[#23F47C]">
          {icon}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
